// extracted by mini-css-extract-plugin
export default {"background":"#f0f2f5","white":"#fff","black":"#000","dark":"#333","error":"#f5222d","border":"#f0f0f0","header":"#001528","layout":"AccessDenied_layout__62gyQ"};